"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrialActivationButtonPropsInterface = void 0;

var _react = require("react");

var TrialActivationButtonPropsInterface = {
  trialId: _react.PropTypes.number,
  shouldHideSurvey: _react.PropTypes.bool,
  onSuccess: _react.PropTypes.func,
  successModalHeader: _react.PropTypes.node,
  successModalSubText: _react.PropTypes.node
};
exports.TrialActivationButtonPropsInterface = TrialActivationButtonPropsInterface;